export default "__VITE_ASSET__4a54561d__"